export const IPROC_SUBTYPES = ["STANDARD_AGR", "TERMINATION", "PROLONGATION", "UMBRELLA"];

export const IPROC_SUBTYPE_PROP = "Доп. соглашение"; // костыль на показ подтипов

export const IPROC_STYLES = [
    { name: "Счёт", isDefault: "1" },
    { name: "Прогноз", isDefault: "1" },
    { name: "Разовый договор", isDefault: "1" },
    { name: "Рамочный договор (без денег)", isDefault: "1" },
    { name: "Рамочный договор и спецификация", isDefault: "1" },
    { name: "Доп. соглашение", isDefault: "1" },
    { name: "Счёт-оферта", isDefault: "1" }
];

export const IPROC_STYLES_EN = [
    { name: "Account", isDefault: "1" },
    { name: "Forecast", isDefault: "1" },
    { name: "One-time contract", isDefault: "1" },
    { name: "Framework contract (without money)", isDefault: "1" },
    { name: "Framework contract and specification", isDefault: "1" },
    { name: "Additional agreement", isDefault: "1" },
    { name: "Invoice offer", isDefault: "1" }
];

export const getDefaultIprocStyles = () => {
    return IPROC_STYLES.filter(s => s.isDefault === "1").map(s => s.name);
};

